import React, { FC, useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './SecureLogIn.module.scss';
import { LogoDark } from 'esa-ui-library';
import { EmailForm, PasswordForm } from '../..';
import { useStore } from '../../../common';
import { AuthContext } from '../../../logic';

interface SecureLogInProps {
	token: string;
}

const SecureLogIn: FC<SecureLogInProps> = ({ token }): JSX.Element => {
	const [, dispatch] = useStore(false);
	const { login, loginType } = useContext(AuthContext);

	const onEmailSubmit = () => {
		dispatch('EMAIL_SUBMIT', { loginType });
	};

	const onPasswordSubmit = () => {
		dispatch('PASS_SUBMIT', { login, loginType });
	};

	return (
		<section className={styles.Secure}>
			<section>
				<LogoDark />
				<div className={styles.SecureContent}>
					<h2>Welcome Back</h2>
					<p className={styles.Explanation}>Sign in to continue to use backoffice services.</p>
					{!token && <EmailForm onSubmit={onEmailSubmit} />}
					{token && <PasswordForm onSubmit={onPasswordSubmit} />}
				</div>
			</section>
		</section>
	);
};

SecureLogIn.propTypes = {
	token: PropTypes.string.isRequired,
};

export { SecureLogIn };
